import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { SearchBar } from '@xingternal/incremental-search';
import { PersonalBar } from '../PersonalBar';
import styles from './LoggedInSubHeader.css';
import { UpsellButton } from './UpsellButton';
const LoggedInSubHeader = ({ hasActiveSearchBar, helpLink }) => (React.createElement(Fragment, null,
    React.createElement("div", { className: cx(styles.searchBarWrapper, {
            [styles.hasActiveSearchBar]: hasActiveSearchBar,
        }) },
        React.createElement(SearchBar, { type: "header" })),
    React.createElement("div", { className: styles.personalBarWrapper },
        React.createElement(PersonalBar, { helpLink: helpLink })),
    React.createElement(UpsellButton, null)));
LoggedInSubHeader.propTypes = {
    // xingConnect
    hasActiveSearchBar: PropTypes.bool,
    // Props
    helpLink: PropTypes.string,
};
export { LoggedInSubHeader };
//# sourceMappingURL=LoggedInSubHeader.js.map